import { GapSelect, type GapContentItemProps } from '.';

export function GapContentItem(gapContentItemProps: GapContentItemProps) {
  const { value, gap, content, onGapValueChange, correct, showMarked } = gapContentItemProps;
  if (gap) return <GapSelect gap={gap} value={value} onValueChange={onGapValueChange} correct={correct} showMarked={showMarked} />;
  return <p>{content}</p>;
}
